import { LModal, LModalFooterButtons } from "@components";
import { ExamineeContactInfo } from "@fadmin/tabs/assessments/store/newExamineeSlice";
import { StartAssessmentStepNames } from "@fadmin/tabs/assessments/store/startAssessmentSlice";
import { useState } from "react";
import { StartAssessmentBody } from "./StartAssessmentBody";

const startAssessmentFormSteps = [StartAssessmentStepNames.AssessmentForm, StartAssessmentStepNames.Checklist];

export const StartAssessmentModal = ({
    examinee,
    locationId,
    upcomingAssessmentId,
    onClose
}: StartAssessmentModalProps): JSX.Element => {
    const [currentStartAssessmentFormStep, setCurrentStartAssessmentFormStep] = useState(0);

    const handleOnStartAssessmentClose = (): void => {
        if (currentStartAssessmentFormStep > 0) {
            setCurrentStartAssessmentFormStep(currentStartAssessmentFormStep - 1);
        } else {
            onClose?.();
        }
    };

    const handleOnStartAssessmentConfirm = (): void => {
        const nextCurrentStep = currentStartAssessmentFormStep + 1;
        setCurrentStartAssessmentFormStep(nextCurrentStep);
    };

    return (
        <LModal
            onClose={handleOnStartAssessmentClose}
            onConfirm={handleOnStartAssessmentConfirm}
            footer={<LModalFooterButtons confirmText="Next" cancelText="< Back" />}
            width={"m"}
            fullHeight={false}
        >
            <StartAssessmentBody
                currentStep={startAssessmentFormSteps[currentStartAssessmentFormStep]}
                examinee={examinee}
                locationId={locationId}
                upcomingAssessmentId={upcomingAssessmentId}
            />
        </LModal>
    );
};

interface StartAssessmentModalProps {
    examinee: ExamineeContactInfo;
    locationId: number;
    upcomingAssessmentId?: number;
    onClose?: () => void;
}
